import Button from '@mostrans/web-components/components/base/Button';
import { Icon } from '@mui/material';
import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { useGetMasterTestimoniWithFilter } from '../../../../GQL/Testimonial/useGetMasterTestimoniWithFilter';
import PageContainer from '../../../../components/Container/PageContainer';
import { titleAtoms } from '../../../../shared/atoms/titleAtoms';
import { useModals } from '../../../../shared/hooks/useModals';
import HeaderFilterTestimonial from './HeaderFilterTestimonial';
import ListingTestimonial from './ListingTestimonial';

function TestimonialManagement() {
  const setTitle = useSetRecoilState(titleAtoms);
  const { showModal } = useModals()
  const { dataTestimoni } = useGetMasterTestimoniWithFilter()

  useEffect(() => {
    setTitle("Testimonial Management");
  }, []);

  return (
    <PageContainer>
      <HeaderFilterTestimonial />
      <div className='mt-2'>
        {
          !dataTestimoni.loading && (
            <Button
              variant='contained'
              startIcon={<Icon>add_circle</Icon>}
              onClick={() => showModal("createTestimoni")}
            >
              Add New Testimonial
            </Button>
          )
        }
      </div>
      <ListingTestimonial />
    </PageContainer>
  )
}

export default TestimonialManagement